export default __webpack_public_path__ + "306e68baf374b5989da5fca6667927e0.png";